import { LoadingButton } from '@atlaskit/button';
import ProgressBar from '@atlaskit/progress-bar';
import React from 'react';
import styled from 'styled-components';

interface HeaderOverlayProps {
  selectedAmount: number;
  syncSelected: () => void;
  isSyncLoading: boolean;
  syncProgress: number;
}

export function SyncAllButton({
  selectedAmount,
  syncSelected,
  isSyncLoading,
  syncProgress,
}: HeaderOverlayProps) {
  return (
    <SyncAllButtonWrapper>
      <LoadingButton
        appearance={selectedAmount ? 'primary' : 'default'}
        onClick={syncSelected}
        isLoading={isSyncLoading}
        isDisabled={!selectedAmount}
      >
        Sync ({selectedAmount})
      </LoadingButton>
      {isSyncLoading ? <ProgressBar value={syncProgress} /> : null}
    </SyncAllButtonWrapper>
  );
}

const SyncAllButtonWrapper = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 4px;
`;
